import React, {useEffect, useMemo} from "react";
import {Button, Row} from "antd";
import {useGetIssuesSalesListQuery} from "@mwServices/Issue";
import BookCover from "@components/book-cover";
import {showInfoModal} from "@lib/showModal";
import {InfoIcon} from "@components/icons/Icons";
import {formatMoney} from "@lib/format";

const HomePageTopTen = ({windowDimensions, onLoad, targetDate}) => {

    const issueParams = useMemo(() => ({
        filters: {
            query: '',
            showVariants: true,
            sort: 24, //default to sales list ids order in array.
        },
        listType: "WEEKLY_TOP_TEN",
        targetDate: targetDate,
        page: 1,
        perPage: 20,
    }), [targetDate]);
    const issueQuery = useGetIssuesSalesListQuery(issueParams);

    const displayDate = useMemo(() => {
        if(targetDate) {
            const dateParts = targetDate.split('-');
            return "(week ending "+dateParts[1]+"/"+dateParts[2]+")";
        }
        return "";
    }, [targetDate]);

    const topTenIssues = useMemo(() => {
        return issueQuery && issueQuery.data ? issueQuery.data.issues.slice(0,10) : [];
    }, [issueQuery]);

    const runnerUpIssues = useMemo(() => {
        return issueQuery && issueQuery.data ? issueQuery.data.issues.slice(10,20) : [];
    }, [issueQuery]);

    const smallScreen = useMemo(() => {
        return windowDimensions.under(600);
    }, [windowDimensions]);

    const articleUrl = useMemo(() => {
        return issueQuery && issueQuery.data ? issueQuery.data.article_url : '';
    }, [issueQuery]);

    useEffect(() => {
        if(issueQuery.data) onLoad();
    }, [issueQuery]);

    return (
        <>
            <div className="homepage-top-ten covr-contain mar-top-20">
                <h2>
                    Weekly Top 10 {displayDate}
                    <Button onClick={() =>{
                        showInfoModal({
                            title: "COVPRICE Weekly Top 10",
                            content: (
                                <>
                                    <p>
                                        Our Top 10 and Runners Up lists are 100% data-driven, reflecting the last 7  days of actual aftermarket sales.
                                        Our algorithms consider major sales, units sold, and percent growth in deciding which comics make the list.
                                        This approach makes COVRPRICE the best place to see what's really happening across the aftermarket.
                                    </p>
                                </>
                            ),
                        });
                        }} type="link" className="text-grey" icon={<InfoIcon className={"iconLarge iconGrey "}/>}
                    />
                </h2>
                {topTenIssues && (<>
                    <div className="top-ten-grid">
                        {topTenIssues.map((issue, i) => (
                            <div key={i} className="top-ten-item">
                                <div className={'issue-num'}><span className="issue-hash">#</span>{i + 1}</div>
                                <a href={`/issue/${issue.slug}`}>
                                    <BookCover issue={issue} preview={false}/>
                                </a>
                                <div className="homepage-item-subtitle mar-top-5">
                                    Top Sale
                                </div>
                                <div className="homepage-item-title">
                                    {issue.sales_list_data.top_sale_price ? (
                                        <>
                                            <div>{issue.sales_list_data.top_sale_graded === 1 ? 'SLAB' : 'RAW'} {issue.sales_list_data.top_sale_grade}</div>
                                            <div>{formatMoney(issue.sales_list_data.top_sale_price)}</div>
                                        </>
                                    ) : (
                                        <>
                                            <div>{issue.sales_list_data.in_grade_graded === 1 ? 'SLAB' : 'RAW'} {issue.sales_list_data.in_grade_grade}</div>
                                            <div>{formatMoney(issue.sales_list_data.in_grade_high_sale)}</div>
                                        </>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                    <Row justify="center" className="mar-top-15 mar-bot-10">
                    <Button className="homepage-section-big-button" href={articleUrl}>Top 10 Article</Button>
                    </Row>
                </>)}
            </div>
            <div className="homepage-top-ten runners-up covr-contain">
                <h2>Runners Up</h2>
                {runnerUpIssues && (<>
                    <div className="top-ten-grid">
                        {runnerUpIssues.map((issue, i) => (
                            <div key={i} className="top-ten-item">
                                <div className={'issue-num'}><span className="issue-hash">#</span>{i + 11}</div>
                                <a href={`/issue/${issue.slug}`}>
                                    <BookCover issue={issue} preview={false}/>
                                </a>
                                <div className="homepage-item-subtitle mar-top-5">
                                    Top Sale
                                </div>
                                <div className="homepage-item-title">
                                    {issue.sales_list_data.top_sale_price ? (
                                        <>
                                            <div>{issue.sales_list_data.top_sale_graded === 1 ? 'SLAB' : 'RAW'} {issue.sales_list_data.top_sale_grade}</div>
                                            <div>{formatMoney(issue.sales_list_data.top_sale_price)}</div>
                                        </>
                                    ) : (
                                        <>
                                            <div>{issue.sales_list_data.in_grade_graded === 1 ? 'SLAB' : 'RAW'} {issue.sales_list_data.in_grade_grade}</div>
                                            <div>{formatMoney(issue.sales_list_data.in_grade_high_sale)}</div>
                                        </>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </>)}
            </div>
        </>
    );
};

export default HomePageTopTen;